import {Component} from '@angular/core';
import {UserService} from "./shared/services/api_v1/user.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    constructor(private user: UserService, private router:Router) {
    }

    logout(): void {
        this.user.logout();
        this.router.navigateByUrl('/home');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts